export default __webpack_public_path__ + "/dist/images/cart-icon.7d4a3bcc0a58ba12af45120d21a9219f.svg";